import { environment } from '../../../environments/environment';

export const Globals = {
  version: '2.27.1',
  serverEndpoint: environment.serverEndpoint,
  websiteRacine: environment.websiteRacine,
  aodRacine: environment.aodRacine,
  appLocation: environment.appLocation,
  codeModificationSpots: 'sun93fm',
  devBypassAuth: environment.devBypassAuth
};
